import React from "react";
import AttendanceMonthlyReportList from "./AttendanceMonthlyReportList";

function InternMonthlyAttendanceReportList() {
  return (
    <AttendanceMonthlyReportList
      defaultPersonTypeId="2"
      heading="Intern Monthly Attendance Report"
      routePath="/intern/attendance/monthly-report"
      monthYearFilterOnly
    />
  );
}

export default InternMonthlyAttendanceReportList;

